// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AssetOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AssetOffIcon" ref={forwardedRef} {...props}>
      <path d="m5.72 11.78-2.47 2.47 1.06 1.06L17.04 2.584l-1.061-1.06L14 3.5H4.997l-2 4.484zm.875-.875-1.76-2.921H6.86l.616 2.04zM8.61 8.89 8.416 7.984h1.1zm2.148-2.148H8.32l.147-1.747h3.065l.026.948zm-5.923 0 .733-1.747H6.96l-.1 1.747z" />
      <path d="m9.39 16.9-1.9-2.649.699-.699.704 1.17-.435-1.44.9-.9.642 2.99.987-4.616 1.886-1.886-1.736 5.853 4.016-6.74H13.76L16 5.744l.998 2.24-6.387 8.915a.75.75 0 0 1-1.22 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AssetOffIcon = /* @__PURE__ */ Object.assign(
  AssetOffIconComponent,
  { displayName: 'AssetOffIcon' },
);
